"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ColumnDataType;
(function (ColumnDataType) {
    ColumnDataType["String"] = "string";
    ColumnDataType["Numeric"] = "numeric";
    ColumnDataType["Boolean"] = "boolean";
    ColumnDataType["Date"] = "date";
    ColumnDataType["DateTime"] = "datetime";
    ColumnDataType["DateTimeUtc"] = "datetimeutc";
})(ColumnDataType = exports.ColumnDataType || (exports.ColumnDataType = {}));
var ColumnSortDirection;
(function (ColumnSortDirection) {
    ColumnSortDirection["None"] = "None";
    ColumnSortDirection["Ascending"] = "Ascending";
    ColumnSortDirection["Descending"] = "Descending";
})(ColumnSortDirection = exports.ColumnSortDirection || (exports.ColumnSortDirection = {}));
var CompareOperators;
(function (CompareOperators) {
    CompareOperators["None"] = "None";
    CompareOperators["Auto"] = "Auto";
    CompareOperators["Equals"] = "Equals";
    CompareOperators["NotEquals"] = "NotEquals";
    CompareOperators["Contains"] = "Contains";
    CompareOperators["StartsWith"] = "StartsWith";
    CompareOperators["EndsWith"] = "EndsWith";
    CompareOperators["Gte"] = "Gte";
    CompareOperators["Gt"] = "Gt";
    CompareOperators["Lte"] = "Lte";
    CompareOperators["Lt"] = "Lt";
    CompareOperators["Between"] = "Between";
    CompareOperators["NotContains"] = "NotContains";
    CompareOperators["NotStartsWith"] = "NotStartsWith";
    CompareOperators["NotEndsWith"] = "NotEndsWith";
})(CompareOperators = exports.CompareOperators || (exports.CompareOperators = {}));
var AggregateFunctions;
(function (AggregateFunctions) {
    AggregateFunctions["None"] = "None";
    AggregateFunctions["Sum"] = "Sum";
    AggregateFunctions["Average"] = "Average";
    AggregateFunctions["Count"] = "Count";
    AggregateFunctions["DistinctCount"] = "DistinctCount";
    AggregateFunctions["Max"] = "Max";
    AggregateFunctions["Min"] = "Min";
})(AggregateFunctions = exports.AggregateFunctions || (exports.AggregateFunctions = {}));
